import {Component, Input} from '@angular/core';
import {CatalogRecord} from '@raven';

@Component({
  selector: 'rn-grid-item',
  templateUrl: './grid-item.component.html',
  styleUrl: './grid-item.component.scss',
  standalone: false
})
export class GridItemComponent {

  @Input() catalogRecord: CatalogRecord;
}
